export default __webpack_public_path__ + "static/media/alert-circle-red.091bc11c.svg";